module.exports = __webpack_public_path__ + "assets/img/elem1-ability2.b212a08d.gif";